import AppValues from 'src/app/common/app.values';
import { CardInfoType } from 'src/app/components/profile/profile.enum';
import { CardModelType } from '../../common/custom.types';
import { CardContent, CardModel, ItemStatus } from '../../interfaces/views.interface';
import { AccountStatus } from '../../swagger-api';

export function emptyCard(): CardModel {
  return {
    id: '',
    header: '',
    title: '',
    buttonHint: '',
    buttonRouterLink: '',
    description: '',
    status: ItemStatus.EMPTY,
    descriptionType: CardInfoType.string,
    created: { date: '', dateFormat: AppValues.DATE_FORMAT_LONG },
    actionBtnHint: '',
    image: '',
    actionBtnId: '',
    actionDisabled: false,
  };
}

export const cardDeleted: CardModelType = {
  entity_id: null,
  creator: {
    user_id: '',
    displayed_name: '',
    is_admin: false,
    account_status: AccountStatus.DELETED,
  },
  permissions: null,
  title: null,
  date: null,
  social_context: null,
};

export const basicCardContent: CardContent = {
  card: emptyCard(),
  index: 0,
};

export const unsupportedCardError: (type: string) => string = (type: string) => `Unsupported card type: ${type}`;
